module.exports = __webpack_public_path__ + "img/_Nobi.a0b64c49.png";